import React, { createContext, useState, ReactNode } from "react";
import { Notification, NotificationContextType } from "./topchef.types";


export const NotificationContext = createContext<NotificationContextType>({
  notification: null,
  triggerNotification: (_notification: Notification) => {},
  clearNotification: () => {}
});

interface NotificationProviderProps {
  children: ReactNode;
}

export const NotificationProvider: React.FC<NotificationProviderProps> = ({ children }) => {

  const [notification, setNotification] = useState<Notification | null>(null);

  const triggerNotification = function (notification: Notification) {
    setNotification(notification);
  }

  const clearNotification = function() {
    setNotification(null);
  }
  return (
    <NotificationContext.Provider value={{ notification, triggerNotification, clearNotification }}>
      {children}
    </NotificationContext.Provider>
  );

};